module.exports = "<small *ngIf=\"mostraErro?.required && submitted\" class=\"form-text\">\n  *O campo é Obrigatório\n</small>\n\n<small *ngIf=\"mostraErro?.minlength && submitted\" class=\"form-text\">\n  *Quantidade miníma de {{ mostraErro.minlength.requiredLength }} caracteres.\n</small>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/field-msg-error/field-msg-error.component.html
// module id = ./src/app/components/field-msg-error/field-msg-error.component.html
// module chunks = main